(function ($) {
  'use strict';

  var cfg = window.customwearCartDrawer || {};

  function wcAjaxUrl(endpoint) {
    var tpl = cfg.wcAjaxUrl || '';
    if (!tpl || tpl.indexOf('%%endpoint%%') === -1) {
      return '';
    }
    return tpl.replace('%%endpoint%%', endpoint);
  }

  function applyFragments(fragments) {
    if (!fragments || typeof fragments !== 'object') {
      return;
    }

    $.each(fragments, function (key, html) {
      if (!key || typeof html !== 'string') {
        return;
      }
      var $targets = $(key);
      if ($targets.length) {
        $targets.replaceWith(html);
      }
    });

    $(document.body).trigger('wc_fragments_refreshed');
  }

  function openDrawer() {
    document.dispatchEvent(new CustomEvent('cw:open-cart-drawer'));
  }

  function setMiniCartBusy(busy) {
    var $panel = $('#cw-cart-panel');
    if (!$panel.length) {
      return;
    }
    $panel.toggleClass('is-updating', !!busy);
    var $content = $panel.find('.widget_shopping_cart_content');
    if ($content.length && $.fn.block) {
      if (busy) {
        $content.block({ message: null, overlayCSS: { background: '#fff', opacity: 0.55 } });
      } else {
        $content.unblock();
      }
    }
  }

  function removeFromCart($btn) {
    var url = wcAjaxUrl('remove_from_cart');
    var cartItemKey = $btn.data('cart_item_key');
    if (!url || !cartItemKey) {
      return;
    }

    setMiniCartBusy(true);

    $.ajax({
      type: 'POST',
      url: url,
      data: { cart_item_key: cartItemKey },
      dataType: 'json',
      success: function (response) {
        if (!response) {
          return;
        }
        if (response.fragments) {
          applyFragments(response.fragments);
        }
        $(document.body).trigger('removed_from_cart', [response.fragments, response.cart_hash, $btn]);
      },
      complete: function () {
        setMiniCartBusy(false);
      },
    });
  }

  window.CustomWearCart = {
    applyFragments: applyFragments,
    openDrawer: openDrawer,
  };

  $(document.body).on('added_to_cart', function (_e, fragments) {
    if (fragments) {
      applyFragments(fragments);
    }
    openDrawer();
  });

  $(document.body).on('click', '.remove_from_cart_button', function (e) {
    if (!wcAjaxUrl('remove_from_cart')) {
      return;
    }
    e.preventDefault();
    removeFromCart($(this));
  });

  $(document.body).on('wc_fragment_refresh', function () {
    var url = wcAjaxUrl('get_refreshed_fragments');
    if (!url) {
      return;
    }
    $.post(url, function (response) {
      if (response && response.fragments) {
        applyFragments(response.fragments);
      }
    });
  });
})(jQuery);
